/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irregular_Presence_HabitInputs */



/**
* | output |
* | --- |
* | "Irregular presence habit" |
*
* @param {Irregular_Presence_HabitInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const irregular_presence_habit = /** @type {((inputs?: Irregular_Presence_HabitInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irregular_Presence_HabitInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Irregular presence habit")
	return /** @type {LocalizedString} */ ("Habitude de présence irrégulière")
});